import { Link } from "react-router-dom";
import BBBTrust from "./BBBTrust";

export default function Footer() {
    return (
        <footer className="mt-20 border-t border-gray-200 bg-white">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">

                {/* Links row */}
                <nav className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-gray-600">
                    <Link to="/about" className="hover:text-indigo-600">About</Link>
                    <Link to="/contact" className="hover:text-indigo-600">Contact</Link>
                    <Link to="/solutions" className="hover:text-indigo-600">Solutions</Link>
                    <Link to="/privacy" className="hover:text-indigo-600">Privacy Policy</Link>
                    <Link to="/terms" className="hover:text-indigo-600">Terms of Service</Link>
                    <a
                        href="mailto:info@secureidtechnologies.com"
                        className="hover:text-indigo-600"
                    >
                        Email
                    </a>
                    <Link to="/trust" className="hover:text-indigo-600">Trust</Link>

                </nav>

                {/* Divider */}
                <div className="my-8 h-px bg-gray-100" />

                {/* Logo + BBB + copyright */}
                <div className="flex flex-col items-center gap-4">

                    {/* Company logo */}
                    <img
                        src="/logo-navbar.png"
                        alt="SecureID Technologies"
                        className="h-10 w-auto"
                    />

                    {/* BBB Seal */}
                    <div className="mt-2 rounded-md bg-white p-2">
                        <BBBTrust size="small" />
                    </div>

                    {/* Copyright */}
                    <p className="text-sm text-gray-600 text-center leading-relaxed">
                        &copy; {new Date().getFullYear()} SecureID Technologies LLC <br />
                        Vero Beach, FL � All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
